/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { useBudgetService } from 'domain/shared/budget';
import BudgetForm from 'domain/finance/budget/createupdate/BudgetForm';
import { CreateForm } from 'framework/form';
import CreateBudgetBreadcrumbs from 'domain/finance/budget/createupdate/Create/Breadcrumbs';
import { useBudgetId } from 'domain/finance/budget/shared/useBudgetId';
import { useBudgetUrl } from 'domain/shared/budget';

const CreateBudget = () => {
  const { create, getValidationSchema, getById } = useBudgetService();
  const { getListUrl } = useBudgetUrl();
  const id = useBudgetId();
  let getDataFunc;

  if (id) {
    getDataFunc = () => getById(id);
  }

  return (
    <CreateForm
      getDataFunc={getDataFunc}
      submitFormFunc={create}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Budget has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Budget" breadcrumbs={<CreateBudgetBreadcrumbs />}>
        <BudgetForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateBudget;
